<template>
    <a v-if="isUrl"
       class="field-value"
       :href="displayValue"
       target="_blank">
        {{ displayValue }}
    </a>
    <span v-else
          class="field-value">
        {{ instance.getDisplayValue(true) }}
    </span>
</template>

<script>
import FieldType from '@/lib/CustomFields/FieldType';
import { calculateAgeFromDob } from '@/functions/age';

export default {
    components: {},

    props: {
        /**
         * @type {FieldInstance}
         */
        instance: {
            type: Object,
            required: true,
        },
    },

    computed: {
        displayValue() {
            return this.instance.getDisplayValue(true);
        },

        isUrl() {
            // Determine if the value of the field looks like a URL.
            return this.displayValue && (new RegExp(/^https?:\/\//)).test(this.displayValue);
        },
    },

    created() {
        if (this.instance.field?.type === FieldType.DOB && this.instance.value) {
            this.instance.age = calculateAgeFromDob(this.instance.value);
        }
    },
};
</script>
